import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { useAuthStore } from '@/store/authStore'

const PUBLIC_ROUTES = ['/login']

export const useRouteGuard = () => {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const location = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname)

    // If on public route and authenticated, redirect to home
    if (isPublicRoute && isAuthenticated) {
      navigate('/', { replace: true })
    }
    // If on protected route and not authenticated, redirect to login
    else if (!isPublicRoute && !isAuthenticated) {
      navigate('/login', { replace: true })
    }
  }, [location.pathname, isAuthenticated, navigate])
}
